import { useCallback, useState } from "react";

const STORAGE_KEY_PREFIX = "vecta-nav-tip-hidden-until";
export const NAV_TIP_SNOOZE_MS = 14 * 24 * 60 * 60 * 1000;

export const navTipKey = (username: string) => `${STORAGE_KEY_PREFIX}:${username}`;

export const isNavTipSnoozed = (key: string, now = Date.now()): boolean => {
  try {
    const until = Number(localStorage.getItem(key));
    return Number.isFinite(until) && until > now;
  } catch {
    return false;
  }
}

export const useNavTipSnooze = (key: string) => {
  const [snoozed, setSnoozed] = useState(() => isNavTipSnoozed(key));

  const snooze = useCallback(() => {
    try {
      localStorage.setItem(key, String(Date.now() + NAV_TIP_SNOOZE_MS));
    } catch {
      // storage unavailable; the tip is only hidden for this page view
    }
    setSnoozed(true);
  }, [key]);

  return { snoozed, snooze };
}
